/**
 * Stili cromatici per Widget Tier (e eventualmente Buttons).
 * Porpora è volutamente più scuro e distinto dal viola.
 * headerBgColor/headerTextColor/bodyTextColor: valori CSS per stili inline (testo leggibile: chiaro su scuro, scuro su chiaro).
 */
export const CHROMATIC_STYLES = {
  default: {
    name: 'Default',
    gradient: 'from-gray-700 to-gray-800',
    border: 'border-gray-300',
    bg: 'from-gray-50 to-gray-100',
    headerBg: 'bg-gray-800',
    headerText: 'text-white',
    headerBgColor: '#1f2937',
    headerTextColor: '#ffffff',
    bodyTextColor: '#374151',
    icon: 'bg-gray-600',
    text: 'text-gray-700',
  },
  white: {
    name: 'Bianco',
    gradient: 'from-gray-100 to-white',
    border: 'border-gray-300',
    bg: 'from-white to-gray-50',
    headerBg: 'bg-white',
    headerText: 'text-gray-800',
    headerBgColor: '#ffffff',
    headerTextColor: '#1f2937',
    bodyTextColor: '#374151',
    icon: 'bg-gray-400',
    text: 'text-gray-700',
  },
  gray: {
    name: 'Grigio',
    gradient: 'from-gray-500 to-gray-600',
    border: 'border-gray-400',
    bg: 'from-gray-100 to-gray-200',
    headerBg: 'bg-gray-600',
    headerText: 'text-white',
    headerBgColor: '#4b5563',
    headerTextColor: '#ffffff',
    bodyTextColor: '#374151',
    icon: 'bg-gray-500',
    text: 'text-gray-700',
  },
  red: {
    name: 'Rosso',
    gradient: 'from-red-600 to-red-700',
    border: 'border-red-300',
    bg: 'from-red-50 to-red-100',
    headerBg: 'bg-red-700',
    headerText: 'text-white',
    headerBgColor: '#b91c1c',
    headerTextColor: '#ffffff',
    bodyTextColor: '#991b1b',
    icon: 'bg-red-600',
    text: 'text-red-800',
  },
  black: {
    name: 'Nero',
    gradient: 'from-gray-900 to-black',
    border: 'border-gray-700',
    bg: 'from-gray-800 to-gray-900',
    headerBg: 'bg-black',
    headerText: 'text-white',
    headerBgColor: '#000000',
    headerTextColor: '#ffffff',
    bodyTextColor: '#e5e7eb',
    icon: 'bg-gray-800',
    text: 'text-gray-200',
  },
  ochre: {
    name: 'Ocra',
    gradient: 'from-amber-700 to-yellow-800',
    border: 'border-amber-300',
    bg: 'from-amber-50 to-yellow-100',
    headerBg: 'bg-amber-800',
    headerText: 'text-white',
    headerBgColor: '#92400e',
    headerTextColor: '#ffffff',
    bodyTextColor: '#78350f',
    icon: 'bg-amber-600',
    text: 'text-amber-900',
  },
  blue: {
    name: 'Blu',
    gradient: 'from-blue-600 to-blue-700',
    border: 'border-blue-300',
    bg: 'from-blue-50 to-blue-100',
    headerBg: 'bg-blue-700',
    headerText: 'text-white',
    headerBgColor: '#1d4ed8',
    headerTextColor: '#ffffff',
    bodyTextColor: '#1e40af',
    icon: 'bg-blue-600',
    text: 'text-blue-800',
  },
  yellow: {
    name: 'Giallo',
    gradient: 'from-yellow-500 to-amber-500',
    border: 'border-yellow-300',
    bg: 'from-yellow-50 to-amber-50',
    headerBg: 'bg-yellow-500',
    headerText: 'text-gray-900',
    headerBgColor: '#eab308',
    headerTextColor: '#111827',
    bodyTextColor: '#713f12',
    icon: 'bg-yellow-600',
    text: 'text-yellow-900',
  },
  purple: {
    name: 'Viola',
    gradient: 'from-violet-600 to-purple-700',
    border: 'border-violet-300',
    bg: 'from-violet-50 to-purple-50',
    headerBg: 'bg-violet-700',
    headerText: 'text-white',
    headerBgColor: '#6d28d9',
    headerTextColor: '#ffffff',
    bodyTextColor: '#5b21b6',
    icon: 'bg-violet-600',
    text: 'text-violet-800',
  },
  green: {
    name: 'Verde',
    gradient: 'from-green-600 to-emerald-700',
    border: 'border-green-300',
    bg: 'from-green-50 to-emerald-50',
    headerBg: 'bg-green-700',
    headerText: 'text-white',
    headerBgColor: '#15803d',
    headerTextColor: '#ffffff',
    bodyTextColor: '#166534',
    icon: 'bg-green-600',
    text: 'text-green-800',
  },
  porpora: {
    name: 'Porpora',
    gradient: 'from-fuchsia-900 to-purple-950',
    border: 'border-fuchsia-700',
    bg: 'from-fuchsia-100 to-purple-100',
    headerBg: 'bg-fuchsia-950',
    headerText: 'text-white',
    headerBgColor: '#4a044e',
    headerTextColor: '#ffffff',
    bodyTextColor: '#581c87',
    icon: 'bg-fuchsia-800',
    text: 'text-fuchsia-900',
  },
};

// Alias: backend può inviare 'giallo' invece di 'yellow'
CHROMATIC_STYLES.giallo = CHROMATIC_STYLES.yellow;
